import { render, staticRenderFns } from "./disabilityInfos.vue?vue&type=template&id=282ebae0&scoped=true&"
import script from "./disabilityInfos.vue?vue&type=script&lang=ts&"
export * from "./disabilityInfos.vue?vue&type=script&lang=ts&"
import style0 from "./disabilityInfos.vue?vue&type=style&index=0&id=282ebae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ebae0",
  null
  
)

export default component.exports